/**
 * When we click on a domain link, close the mobile menu.
 * Also close mobile menu when screen is resized above mobile breakpoint.
 *
 * @package Ninja Forms builder
 * @subpackage Main App
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'controllers/app/mobile',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			// Listen for clicks on our app menu.
			this.listenTo( nfRadio.channel( 'app' ), 'click:menu', this.closeMobileMenu );

			// Listen for window resize to auto-close menu on desktop
			this.setupResizeListener();
		},

		closeMobileMenu: function() {
			var builderEl = nfRadio.channel( 'app' ).request( 'get:builderEl' );
			jQuery( builderEl ).removeClass( 'nf-menu-expand' );
		},

		/**
		 * Setup window resize listener with debouncing
		 * Automatically closes mobile menu when screen exceeds mobile breakpoint
		 *
		 * @since 3.x
		 * @return void
		 */
		setupResizeListener: function() {
			var that = this;
			var resizeTimer;
			var mobileBreakpoint = 900; // Must match CSS breakpoint in media-queries.scss

			jQuery( window ).on( 'resize.nfMobileMenu', function() {
				clearTimeout( resizeTimer );
				resizeTimer = setTimeout( function() {
					// If window width exceeds mobile breakpoint, close mobile menu
					if ( jQuery( window ).width() > mobileBreakpoint ) {
						that.closeMobileMenu();
					}
				}, 250 ); // Debounce delay in milliseconds
			});
		}

	});

	return controller;
} );
